import { zodResolver } from '@hookform/resolvers/zod';
import React, { useState } from 'react';
// redux
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import * as z from 'zod';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Logo from 'assets/images/logo.svg';
import { forgotPassword } from 'api/auth/forgot-password/forgotPassword';
import { schemaStep1 } from 'api/auth/types';
// @ts-ignore

const ForgotPassword = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [completeForm, setCompleteForm] = useState(false);
  const { t } = useTranslation();
  const formStep1 = useForm({
    resolver: zodResolver(schemaStep1),
    defaultValues: {
      email: '',
    },
  });

  const { mutate: handleForgotPassword, isLoading } = useMutation({
    mutationFn: forgotPassword,
    onSuccess: response => {
      if (response) {
        setCompleteForm(true);
      } else if (response.message) {
        setErrorMessage(response.message);
      }
    },
    onError: (error: any) => {
      if (error.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage('An error occurred during login');
      }
    },
  });

  const onSubmitStep1 = (data: z.infer<typeof schemaStep1>) => {
    setErrorMessage(null);
    handleForgotPassword(data);
  };

  return (
    <div className="auth-page-wrapper pt-5">
      <div className="auth-page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <a href="https://trojan.systems/" className="d-inline-block auth-logo">
                    <img src={Logo} alt="" height="50" />
                  </a>
                </div>
                <p className="mt-3 fs-15 fw-medium text-primary">Smart pest management</p>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4">
                <div className="card-body p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Forgot Password?</h5>
                  </div>

                  <div className="p-2 mt-4">
                    {!completeForm ? (
                      <form key="form-step-1" onSubmit={formStep1.handleSubmit(onSubmitStep1)}>
                        <div className="row">
                          <div className="mb-3 col-12">
                            {' '}
                            <div style={{ width: '100px', height: '100px' }} className="mx-auto">
                              <lord-icon
                                src="https://cdn.lordicon.com/rhvddzym.json"
                                trigger="loop"
                                colors="primary:#0ab39c,secondary:#08a88a"
                                style={{ width: '100%', height: '100%' }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <div className="alert alert-warning text-center mb-4 border-0" role="alert">
                              Enter your email and instructions will be sent to you!
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="mb-3 col-12">
                            <label className="form-label mb-0">
                              Email
                              <span className="text-danger">*</span>
                            </label>
                            <Controller
                              control={formStep1.control}
                              name="email"
                              render={({ field }) => (
                                <input
                                  type="email"
                                  autoFocus
                                  autoCapitalize="none"
                                  autoComplete="email"
                                  maxLength={254}
                                  className="form-control"
                                  required
                                  {...field}
                                />
                              )}
                            />
                          </div>
                        </div>

                        <div className="mt-4">
                          <button
                            type="submit"
                            disabled={isLoading}
                            style={{ backgroundColor: '#0ab39c' }}
                            className="btn text-light w-100 bg-success"
                          >
                            {isLoading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                />
                                Sending...
                              </>
                            ) : (
                              'Send Reset Link'
                            )}
                          </button>
                        </div>
                      </form>
                    ) : (
                      <div className="d-flex justify-content-center align-items-center flex-column">
                        <div className="fs-18">{t('ForgotPassword.title')}</div>
                        <div className="pt-2 text-center">
                          {t('ForgotPassword.subTitle', { email: formStep1.getValues().email || 'your email' })}
                        </div>
                        <div className="pt-5 text-center text-muted">{t('ForgotPassword.description')}</div>
                      </div>
                    )}

                    {errorMessage && (
                      <div className="alert border-0 alert-danger mt-2 text-center" role="alert">
                        <strong>{errorMessage}</strong>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center">
                <p className="mb-0">
                  Wait, I remember my password..
                  <Link to="/login" className="fw-semibold text-primary text-decoration-underline">
                    Sign in
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <p className="mb-0 text-muted">
                  © {new Date().getFullYear()} Trojan LLC. Crafted with <i className="mdi mdi-heart text-danger" /> by
                  Trojan Systems
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default ForgotPassword;
